import { isValidEmail } from '@domain-group/javascript-utils'
import type { ImageModel } from './types'

export type UserModel = {
  actable_id: number,
  actable_type: string,
  actable?: {
    agent_title?: string,
    business_name?: string,
    business_number?: string,
    ebu_admin?: boolean,
    license_number?: string,
    profile?: string,
  },
  api_keys?: number[],
  api_user: boolean,
  association_id?: number,
  association_type?: string,
  brand_id?: number,
  brand_user?: boolean,
  brand_custom_profile_user_profile_ids?: {
    property_marketing?: number,
    agency_marketing?: number,
    notifications?: number,
  },
  cache_key: number,
  country_calling_code?: string,
  custom_permissions: { [key: string]: any },
  customizable_permissions: { [key: string]: any },
  data?: any,
  deleted: boolean,
  email: string,
  enable_custom_permissions: boolean,
  enable_brand_custom_profiles: boolean,
  first_name: string,
  frontend_permissions: any,
  full_name?: string,
  id: number,
  image_id?: number,
  image?: ImageModel,
  impersonated_user?: UserModel,
  last_name: string,
  mobile_number: string,
  options?: {
    training_mode: boolean,
  },
  password?: string,
  password_confirmation?: string,
  realhub_platform?: string,
  role_id: number,
  role_title?: string,
  second_factor_attempts_count: number,
  template_master: boolean,
  time_zone: string,
  type: 'User',
  username: string,
}

export type UserRequestOptions = {
  include_image_sizes?: boolean,
  include_user_image?: boolean,
  include_user_type?: boolean,
  include_brand_custom_profile_user_profile_ids?: boolean,
  include_user_frontend_permissions?: boolean,
}

const state = {
  api_user: false,
  association_id: undefined,
  association_type: '',
  brand_custom_profile_user_profile_ids: {
    property_marketing: undefined,
    agency_marketing: undefined,
    notifications: undefined,
  },
  country_calling_code: '+61',
  custom_permissions: {},
  customizable_permissions: {},
  data: {},
  deleted: false,
  email: '',
  enable_brand_custom_profiles: false,
  enable_custom_permissions: false,
  first_name: '',
  id: null,
  image_id: undefined,
  last_name: '',
  mobile_number: '',
  options: {
    training_mode: false,
  },
  password: '',
  password_confirmation: '',
  role_id: undefined,
  second_factor_attempts_count: undefined,
  template_master: false,
  time_zone: '',
  username: '',
}

export const requiredFields = [
  { key: 'email', validation: isValidEmail, invalidMessage: 'Invalid Email format' },
  { key: 'first_name' },
  { key: 'last_name' },
  { key: 'role_id' },
  { key: 'username' },
]

export default state
